// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  orbitId: __t.u64().primaryKey().name("orbit_id"),
  createdAt: __t.timestamp().name("created_at"),
  lastActivityAt: __t.timestamp().name("last_activity_at"),
  validated: __t.bool(),
  preferredWorldId: __t.u64().name("preferred_world_id"),
});
